interface IProps {
    error: Error
    resetErrorBoundary: () => void
}

export default function ErrorFallback({ error, resetErrorBoundary }: IProps) {
    return (
        <div>
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
            <button onClick={resetErrorBoundary}>Try again</button>
        </div>
    )
}
